/**
 * Aggiorna la barra spedizione gratuita sulla PDP in base al carrello.
 */
(function () {
  function moneyFromCents(cents) {
    var value = Math.max(0, cents) / 100;
    return value.toLocaleString('it-IT', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  function apply(root, total) {
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 3000;
    var textEl = root.querySelector('[data-pdp-shipping-text]');
    var barEl = root.querySelector('[data-pdp-shipping-bar]');
    var remaining = threshold - total;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    if (barEl) barEl.style.width = pct + '%';
    if (!textEl) return;
    if (remaining <= 0) {
      textEl.textContent = root.getAttribute('data-notice-done') || '';
      return;
    }
    var template = root.getAttribute('data-notice-progress') || '';
    textEl.textContent = template.replace(/\{\{\s*money\s*\}\}/g, moneyFromCents(remaining));
  }

  function refresh() {
    var nodes = document.querySelectorAll('[data-pdp-shipping]');
    if (!nodes.length) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        nodes.forEach(function (node) {
          apply(node, total);
        });
      })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (/\/cart\/(add|change|update|clear)/i.test(url)) {
          setTimeout(refresh, 200);
        }
        return res;
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
